/**
 * Panel.tsx - Panel - Base panel component
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
// @ts-nocheck - TODO: Fix TypeScript errors systematically
import React, { useEffect, useMemo } from 'react';
import { usePanel, usePanelResize } from '../PanelrContext';

export const Panel = ({
  id,
  children,
  className = '',
  header = null,
  footer = null,
  collapsible = true,
  resizable = false,
  position = 'left',
  defaultWidth = 320,
  minWidth = 200,
  maxWidth = 600,
  widths = null,
  persistent = true,
  onOpen = () => {},
  onClose = () => {},
  style = {}
}) => {
  useEffect(() => {
    // console.log(`[Panel ${id}] Mounting with position: ${position}, defaultWidth: ${defaultWidth}, widths:`, widths); // Disabled - too noisy
  }, []);

  // Memoize config to prevent re-registration on every render
  const config = useMemo(() => {
    const cfg = {
      collapsible,
      resizable,
      position,
      defaultWidth,
      minWidth,
      maxWidth,
      widths,
      persistent
    };
    // console.log(`[Panel ${id}] Config memoized:`, config); // Disabled - too noisy
    return cfg;
  }, [collapsible, resizable, position, defaultWidth, minWidth, maxWidth, widths, persistent]);
  
  const { state, isOpen, width, open, close, toggle } = usePanel(id, config);
  const { handleMouseDown: handleResizeMouseDown, isDragging } = usePanelResize(id);
  // console.log(`[Panel ${id}] State:`, { state, isOpen, width, isDragging }); // Disabled - too noisy

  const handleToggle = () => {
    const newState = toggle();
    if (newState) {
      onOpen?.();
    } else {
      onClose?.();
    }
  };

  // Use width for left/right, height for top/bottom
  const isHorizontal = position === 'left' || position === 'right';
  const size = width || defaultWidth;
  
  // Z-index: top/bottom panels above left/right panels
  const zIndex = (position === 'top' || position === 'bottom') ? 1000 : 900;
  
  const panelStyle = {
    ...style,
    [isHorizontal ? 'width' : 'height']: `${size}px`,
    // Hide instead of unmounting to preserve state and allow smooth transitions
    display: (state && !isOpen) ? 'none' : 'flex',
    transition: 'width 0.5s ease, height 0.5s ease, opacity 0.5s ease',
    opacity: (state && !isOpen) ? 0 : 1
  };
  // console.log(`[Panel ${id}] Rendering with panelStyle:`, panelStyle); // Disabled - too noisy

  return (
    <div 
      className={`panel ${className} ${isDragging ? 'resizing' : ''}`}
      style={panelStyle}
      data-position={position}
      data-resizable={resizable}
    >
      {header && (
        <div className="panel-header">
          {header}
          {collapsible && (
            <button 
              className="btn btn-ghost btn-sm panel-toggle"
              onClick={handleToggle}
              aria-label="Close panel"
            >
              ✕
            </button>
          )}
        </div>
      )}
      
      <div className="panel-content">
        {children}
      </div>
      
      {footer && (
        <div className="panel-footer">
          {footer}
        </div>
      )}
      
      {resizable && (
        <div 
          className="panel-resize-handle"
          data-position={position}
          onMouseDown={handleResizeMouseDown}
        />
      )}
    </div>
  );
};

export default Panel;
